import Vue from 'vue'
import VueCookies from 'vue-cookies'
import { mapState } from 'vuex'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import vuetify from './plugins/vuetify'
import VueClipboard from 'vue-clipboard2'
import FilterModal from './components/common/filter.vue'
import DataFilter from './components/common/DataFilter.vue'
import newTab from './components/common/newTab.vue'
import vSelect from "vue-select"
import timestamp from 'unix-timestamp'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import VueDraggableResizable from 'vue-draggable-resizable'
import ShortText from '@/components/common/ShortText';

import 'vue-search-select/dist/VueSearchSelect.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import './style/style.sass'

import BootstrapVue from 'bootstrap-vue'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

// import DisableAutocomplete from 'vue-disable-autocomplete';

Vue.component('filter-modal', FilterModal)
Vue.component('data-filter', DataFilter)
Vue.component('new-tab', newTab)
Vue.component("custom-select", vSelect)
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.component('short-text', ShortText)

// Vue.use(DisableAutocomplete);
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(timestamp)
Vue.use(BootstrapVue)
Vue.use(PerfectScrollbar)
Vue.use(VueApexCharts)
Vue.use(ShortText)
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  timestamp,
  render: (h) => h(App)
}).$mount('#app');
